





































import {Vue, Component} from 'vue-property-decorator';
import dataProxy from "@/services/data-proxy.service";
import {formatDate} from "@/utils/formatters";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component
export default class UvozSipanjaGoriva extends mixins(ComponentBaseMixin) {
    uvezeneDatoteke = [];
    provajder = null;
    file = null;
    columns = [];
    tableOptions = {
        pagination: true
    };

    isBusy = false;

    async created() {
        this.uvezeneDatoteke = await this.loadData(() => dataProxy.vratiUvezeneDatotekeSipanjaGoriva())();
        this.columns = [
            {field: 'datum', title: this.$i18n.t('datum unosa'), formatter: formatDate, sortable: true},
            {field: 'naziv', title: this.$i18n.t('naziv datoteke')}
        ]
    }

    async sacuvajFajl() {
        if (this.isBusy) return;
        if (this.file) {
            try {
                this.isBusy = true;
                this.uvezeneDatoteke = await this.saveData(() => dataProxy.uveziSipanjeGoriva({fileName: this.file.name, data: this.file}, this.provajder))();
            } finally {
                this.isBusy = false;
            }
        }
    }
}
